import React from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';
import { blocksToComponents, BLOCK_TYPE } from '../utils/Contentful';
import styled from 'styled-components';

const StyledCollapsible = styled.div`
  border-top: 1px solid ${props => props.borderColor || 'var(--c-slate)'};
  &:last-child {
    border-bottom: 1px solid ${props => props.borderColor || 'var(--c-slate)'};
  }

  .contentOuter {
    transition: height 0.33s ease-in-out !important;
  }

  .contentInner {
    padding: var(--fr) calc(2 * var(--fr));
    padding-bottom: 0;
    border-top: 1px solid ${props => props.borderColor || 'var(--c-slate)'};
  }

  .title {
    flex: 1;
  }

  .trigger {
    width: 100%;
    padding: calc(2 * var(--fr));
    font-size: var(--fs-m);
    text-align: left;
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
      transition: all 0.5s 0s;
      transform-origin: center center;
      transform: rotate(0);
      width: calc(var(--fr) * 1.5);
      height: calc(var(--fr) * 1.5);
    }

    &.is-open {
      svg {
        transform: rotateZ(180deg);
        transform-origin: center center;
      }
    }
  }
`;

const CollapsibleItem = ({ content, borderColor }) => {
  const { title, blocks } = content;

  return (
    <StyledCollapsible borderColor={borderColor}>
      <Collapsible
        trigger={[
          <span key="title" className="title">
            {title}
          </span>,
          <svg
            key="chevron-down-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            viewBox="0 0 900 560"
          >
            <path d="M480,344.181L268.869,131.889c-15.756-15.859-41.3-15.859-57.054,0c-15.754,15.857-15.754,41.57,0,57.431l237.632,238.937c8.395,8.451,19.562,12.254,30.553,11.698c10.993,0.556,22.159-3.247,30.555-11.698l237.631-238.937c15.756-15.86,15.756-41.571,0-57.431s-41.299-15.859-57.051,0L480,344.181z" />
          </svg>,
        ]}
        contentOuterClassName="contentOuter"
        contentInnerClassName="contentInner"
        triggerElementProps={{ 'aria-label': title }}
        triggerTagName="button"
        triggerClassName="trigger"
        triggerOpenedClassName="trigger"
      >
        {blocks &&
          blocks.map(block => blocksToComponents({ block, src: BLOCK_TYPE.COLLAPSIBLE_ITEM }))}
      </Collapsible>
    </StyledCollapsible>
  );
};

CollapsibleItem.propTypes = {
  content: PropTypes.object,
  borderColor: PropTypes.string,
};

export default CollapsibleItem;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/collapsibleBlock/CollapsibleItem.js